import { createContext, useContext } from 'react';

export const ConnectionsContext = createContext(null);

export const useConnectionsContext = () => useContext(ConnectionsContext);
